import { all } from "redux-saga/effects";
import {
  invoiceCreateWatcher,
  invoiceDeleteWatcher,
  invoiceDiscountWatcher,
  invoiceDiscountUpdateWatcher,
  invoiceDraftCreateWatcher,
  invoiceEditWatcher,
  invoiceNumberWatcher,
  invoicePastWatcher,
  pastBillsFamilyMembersWatcher,
  salesItemsBySotIdWatcher,
  topBillsWatcher,
  invoiceTableWatcher,
  invoiceViewWatcher,
  invoiceAlternativeWatcher,
  repeatOrderWatcher,
  storeDetailsWatcher,
  invoiceScannedItemWatcher,
  returnBillTableWatcher,
  returnBillCreateWatcher,
  returnBillUpdateWatcher,
  returnBillViewWatcher,
  returnBillItemsGetWatcher,
  invoiceProductDetailsWatcher,
  fetchBillNumberWatcher,
} from "../invoice-saga";

export default function* invoiceRootSaga() {
  yield all([
    invoiceCreateWatcher(),
    repeatOrderWatcher(),
    invoiceNumberWatcher(),
    invoiceTableWatcher(),
    invoiceDiscountWatcher(),
    invoiceDiscountUpdateWatcher(),
    invoiceViewWatcher(),
    invoiceDraftCreateWatcher(),
    invoiceEditWatcher(),
    invoicePastWatcher(),
    pastBillsFamilyMembersWatcher(),
    salesItemsBySotIdWatcher(),
    topBillsWatcher(),
    invoiceDeleteWatcher(),
    invoiceAlternativeWatcher(),
    storeDetailsWatcher(),
    invoiceScannedItemWatcher(),
    returnBillTableWatcher(),
    returnBillCreateWatcher(),
    returnBillUpdateWatcher(),
    returnBillViewWatcher(),
    returnBillItemsGetWatcher(),
    invoiceProductDetailsWatcher(),
    fetchBillNumberWatcher(),
  ]);
}
